export const SELLERS_SET_SELLERS = 'SELLERS_SET_SELLERS'
